import { useState, useEffect, useCallback } from 'react';
import { useFieldActions } from '../../../contexts/field-actions-context';
export const useServiceDropdownOptions = props => {
  var _props$serviceIds, _props$validation;
  const {
    actions
  } = useFieldActions();
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [isEmpty, setIsEmpty] = useState(((_props$serviceIds = props.serviceIds) == null ? void 0 : _props$serviceIds.length) === 0);
  const serviceIds = ((_props$validation = props.validation) == null || (_props$validation = _props$validation.string) == null ? void 0 : _props$validation.enum) ?? [];
  const initData = useCallback(async () => {
    if (actions != null && actions.fetchServices && serviceIds.length > 0 && !props.isEditor) {
      setIsLoading(true);
      const relevantServices = await actions.fetchServices({
        serviceIds
      });
      const enrichedOptions = (relevantServices == null || relevantServices.map == null ? void 0 : relevantServices.map(service => ({
        value: service.name ?? '',
        label: service.name ?? '',
        id: service.id ?? ''
      }))) ?? [];
      setIsEmpty(enrichedOptions.length === 0);
      setOptions(enrichedOptions);
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceIds, props.isEditor]);
  useEffect(() => {
    initData();
  }, [initData]);
  const onFocus = useCallback(() => {
    if (props.onFocus) {
      props.onFocus();
    }
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onFocus, initData]);
  return {
    isLoading,
    options,
    isEmpty,
    onFocus
  };
};
//# sourceMappingURL=use-service-dropdown-options.js.map